__webpack_public_path__ = window.hwResourcePublicPath // eslint-disable-line camelcase

import 'babel-polyfill'
import Esdp from '@healthwise/enhanced-shared-decision-point'
import React from 'react'
import { render } from 'react-dom'

render(
  <Esdp baseRoute="/Client/Esdp" />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./controllers/esdp.js